export default {
  'workOrder.home.welcome': 'ようこそ',
  'workOrder.common.create': '作業依頼を作成',
  'workOrder.common.refresh': 'データを更新',
  'workOrder.common.reload': '再読み込み',
  'workOrder.common.view': '表示',
  'workOrder.common.all': 'すべて',
  'workOrder.common.none': 'データがありません',
  'workOrder.status.pending_accept': '受付待ち',
  'workOrder.status.processing': '処理中',
  'workOrder.status.pending_confirm': '確認待ち',
  'workOrder.status.closed': '完了',
  'workOrder.status.cancelled': 'キャンセル済み',
  'workOrder.priority.low': '低',
  'workOrder.priority.normal': '通常',
  'workOrder.priority.high': '高',
  'workOrder.priority.critical': '緊急',
  'workOrder.list.title.all': 'すべての作業依頼',
  'workOrder.list.title.todo': '自分の対応待ち',
  'workOrder.list.title.mine': '自分の作業依頼',
  'workOrder.list.ticketNo': '番号',
  'workOrder.list.workOrderTitle': 'タイトル',
  'workOrder.list.priority': '優先度',
  'workOrder.list.status': '状態',
  'workOrder.list.createdAt': '作成日時',
  'workOrder.list.actions': '操作',
  'workOrder.create.title': '作業依頼を作成',
  'workOrder.create.titleWithTemplate': '{name} を作成',
  'workOrder.create.submit': '作業依頼を送信',
  'workOrder.create.submitted': '作業依頼を送信しました',
  'workOrder.create.basicInfo': '基本情報',
  'workOrder.create.extendedInfo': '追加情報',
  'workOrder.create.template': '作業依頼テンプレート',
  'workOrder.create.templateRequired': '作業依頼テンプレートを選択してください',
  'workOrder.create.workOrderTitle': '作業依頼タイトル',
  'workOrder.create.titleRequired': '作業依頼タイトルを入力してください',
  'workOrder.template.title': '作業依頼テンプレート',
  'workOrder.template.create': 'テンプレートを作成',
  'workOrder.template.name': 'テンプレート名',
  'workOrder.template.code': 'テンプレートコード',
  'workOrder.template.currentVersion': '現在のバージョン',
  'workOrder.template.unpublished': '未公開',
  'workOrder.template.status': '状態',
  'workOrder.template.draft': '下書き',
  'workOrder.template.published': '公開済み',
  'workOrder.template.enabled': '有効',
  'workOrder.template.disabled': '無効',
  'workOrder.template.lastPublishedAt': '最終公開日時',
  'workOrder.template.configure': '設定',
  'workOrder.template.copy': '複製',
  'workOrder.template.copied': 'テンプレートを複製しました',
  'workOrder.form.uploadAttachment': '添付ファイルをアップロード',
  'workOrder.puck.options': '選択肢。1 行に 1 件、表示名|コード形式',
  'workOrder.puck.code': 'システムコード',
  'workOrder.puck.label': '表示名',
  'workOrder.puck.helpText': 'ヘルプテキスト',
  'workOrder.puck.placeholder': 'プレースホルダー',
  'workOrder.puck.required': '必須',
  'workOrder.puck.no': 'いいえ',
  'workOrder.puck.yes': 'はい',
  'workOrder.puck.initiatePermission': '起票段階',
  'workOrder.puck.processPermission': '処理段階',
  'workOrder.puck.editable': '編集可',
  'workOrder.puck.readonly': '読み取り専用',
  'workOrder.puck.hidden': '非表示',
  'workOrder.puck.conditionFieldCode': '条件フィールドコード',
  'workOrder.puck.conditionOperator': '条件演算子',
  'workOrder.puck.equals': '等しい',
  'workOrder.puck.notEquals': '等しくない',
  'workOrder.puck.contains': '含む',
  'workOrder.puck.notEmpty': '空ではない',
  'workOrder.puck.conditionValue': '条件値',
  'workOrder.puck.attachmentAccept': '許可する種類',
  'workOrder.puck.attachmentSize': '最大ファイルサイズ（MB）',
  'workOrder.puck.attachmentCount': '最大ファイル数',
  'workOrder.puck.selectFile': 'ファイルを選択',
  'workOrder.puck.fields': '作業依頼フィールド',
  'workOrder.puck.layouts': 'レイアウト',
  'workOrder.puck.text': '一行テキスト',
  'workOrder.puck.textarea': '複数行テキスト',
  'workOrder.puck.number': '数値',
  'workOrder.puck.select': '単一選択',
  'workOrder.puck.multiSelect': '複数選択',
  'workOrder.puck.date': '日付',
  'workOrder.puck.dateRange': '日付範囲',
  'workOrder.puck.member': 'メンバー選択',
  'workOrder.puck.attachment': '添付ファイル',
  'workOrder.puck.switch': 'スイッチ',
  'workOrder.puck.oneColumn': '1 列レイアウト',
  'workOrder.puck.twoColumn': '2 列レイアウト',
  'workOrder.puck.layoutName': 'レイアウト名',
  'workOrder.puck.group': 'グループ',
  'workOrder.puck.groupName': 'グループ名',
  'workOrder.puck.fieldGroup': 'フィールドグループ',
  'workOrder.editor.publishCheckFailed': '公開チェックに失敗しました',
  'workOrder.editor.published': 'テンプレートを公開しました',
  'workOrder.editor.draftSaved': '下書きを保存しました',
  'workOrder.editor.publishFailed': 'テンプレートを公開できませんでした',
  'workOrder.editor.draftSaveFailed': '下書きを保存できませんでした',
  'workOrder.editor.editTitle': 'テンプレートを編集',
  'workOrder.editor.saveDraft': '下書きを保存',
  'workOrder.editor.publish': 'テンプレートを公開',
  'workOrder.editor.basicInfo': '基本情報',
  'workOrder.editor.formDesign': 'フォーム設計',
  'workOrder.editor.workflow': 'フロー設定',
  'workOrder.editor.sla': 'SLA 設定',
  'workOrder.editor.publishCheck': '公開チェック',
  'workOrder.editor.nameRequired': 'テンプレート名を入力してください',
  'workOrder.editor.codeInvalid':
    '小文字、数字、アンダースコアのみ使用できます',
  'workOrder.editor.description': '説明',
  'workOrder.editor.statCategory': '集計カテゴリ',
  'workOrder.editor.enabled': '有効状態',
  'workOrder.editor.preview': 'プレビュー',
  'workOrder.editor.deleteNode': 'ノードを削除',
  'workOrder.editor.nodeCode': 'ノードコード',
  'workOrder.editor.nodeName': 'ノード名',
  'workOrder.editor.nodeType.accept': '受付',
  'workOrder.editor.nodeType.process': '処理',
  'workOrder.editor.nodeType.ownerConfirm': '担当者確認',
  'workOrder.editor.nodeType.requesterConfirm': '起票者確認',
  'workOrder.editor.assignee.member': '指定メンバー',
  'workOrder.editor.assignee.role': '組織ロール',
  'workOrder.editor.assignee.group': '候補グループ',
  'workOrder.editor.selectAssignee': '担当者を選択',
  'workOrder.editor.assigneeCode': '担当者コード',
  'workOrder.editor.responseMinutes': '応答分',
  'workOrder.editor.processMinutes': '処理分',
  'workOrder.editor.requiresResult': '処理結果を必須にする',
  'workOrder.editor.addNode': 'ノードを追加',
  'workOrder.editor.warningLeadTime': '警告リードタイム',
  'workOrder.editor.minutes': '{value} 分',
  'workOrder.editor.hour': '1 時間',
  'workOrder.editor.recheck': '再チェック',
  'workOrder.editor.emptyChecks': '再チェックして結果を表示します',
  'workOrder.editor.passed': '合格',
  'workOrder.editor.failed': '不合格',
  'workOrder.editor.previous': '前へ',
  'workOrder.editor.next': '次へ',
};
